<template>
  <div id="baseFormATCommand" class="content-fade-in">
    <CRow class="pb-2 atcmd-row">
      <CCol sm="12" md="12" xl="12" xs="12" class="atcmd-col">
        <div class="chat-container custom-scroll">
          <!--          <i class="fa fa-spinner fa-spin" v-show="loading.value"-->
          <!--             style="font-size: 50px;color:rgba(128,128,128,0.74);position: absolute;top: 50px; left: 45%;"></i>-->
          <ul ref="chatList" class="chat-list content-chat-list">
            <template v-for="each in items">
              <li v-if="each.cmd" class="chat-item chat-item-sender" v-c-tooltip="$helper.formatDate(each.createDate)">
                <span class="chat-text">{{ each.cmd }}</span>
              </li>
              <li v-if="each.data" class="chat-item chat-item-receiver"
                v-c-tooltip="$helper.formatDate(each.updateDate)">
                <span class="chat-text">{{ each.data }}</span>
              </li>
            </template>
            <li v-if="items.length <= 0" class="chat-empty">
              Hộp thư trống...
            </li>
          </ul>
          <div class="chat-form pt-4">
            <input type="text" placeholder="Type a message..." class="chat-input" v-model="contentCmd"
              @keyup.enter="submitSendATCmd()" ref="inputCmd" @keypress.ctrl="keyPressInput" />
            <input type="text" placeholder="Timeout..." class="timeout-input" v-model="timeoutCmd"
              @keyup.enter="submitSendATCmd()" ref="inputTimout" @keypress.ctrl="keyPressInput" />
            <CButton class="btn btn-primary chat-send" @click.prevent="submitSendATCmd()"><i class="fa fa-send"></i> Gửi
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import { DatePicker } from "v-calendar";
import BaseModal from "@/views/base/BaseModal";

export default {
  name: "BaseFormATCommand",
  components: {
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  props: {
    phoneNumber: String,
    deviceId: String
  },
  data() {
    return {
      loading: { value: false },
      contentCmd: '',
      timeoutCmd: 5,
      pageSize: 10,
      pageNumber: 0,
      totalElement: 0,
      totalPages: 0,
      items: []
    }
  },
  methods: {
    withBrTags: function (doc) {
      return doc.replace(/(\\r)*\\n/g, '<br>')
    },
    loadShowMoreData() {
      let that = this;
      const chatWindow = this.$refs.chatList;
      if (!chatWindow) return;
      const loadMoreThreshold = 200;
      chatWindow.addEventListener('scroll', function () {
        if (!that.loading.value && chatWindow.scrollTop <= loadMoreThreshold) {
          // load thêm dữ liệu ở đây
          if (that.pageNumber < that.totalPages) {
            that.loading.value = true;
            that.loadMessageATCmd();
          }
        }
      });
    },
    keyPressInput(e) {
      if (e.keyCode == 26) {
        this.submitSendATCmd();
      }
    },
    submitSendATCmd() {
      let isValid = true;
      if (this.contentCmd === '' || this.contentCmd === null) {
        isValid = false;
      }
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/sendATCmd",
        dataSubmit() {
          return {
            phoneNumber: that.phoneNumber,
            cmd: encodeURIComponent(that.contentCmd),
            deviceId: that.deviceId,
            timeout: that.timeoutCmd
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.contentCmd = '';
            that.items.push({ cmd: response.data.data.cmd, createDate: response.data.data.createDate })
            that.scrollToBottomChat();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadMessageATCmd() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/getPages",
        dataSubmit() {
          return {
            pageSize: that.pageSize,
            pageNumber: that.pageNumber,
            phoneNumber: that.phoneNumber,
            deviceId: that.deviceId
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.totalElement = response.data.data.totalElement;
            response.data.data.dataContent.content.map(each => that.items.unshift(each));
            that.pageNumber += 1;
            that.totalPages = Math.ceil(that.totalElement / that.pageSize);
            that.loading.value = false;
            that.scrollToBottomChat();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    scrollToBottomChat() {
      this.$nextTick(() => {
        const chatWindow = this.$refs.chatList;
        if (!chatWindow) return;
        chatWindow.scrollTop = chatWindow.scrollHeight - chatWindow.clientHeight;
      });
    }
  },
  created: function () {
  },
  mounted() {
    this.$refs.inputCmd.focus();
    this.loadShowMoreData();
    this.loadMessageATCmd();
    this.scrollToBottomChat();
  },
  watch: {
    '$store.state.atCmd': function (value) {
      this.items.push({ data: value.data.data, updateDate: value.data.updateDate })
      this.scrollToBottomChat();
    }
  },
  computed: {
   
  }
};
</script>
<style scoped>
.atcmd-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.atcmd-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Style for chat container */
.chat-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 80vh;
  min-height: 520px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 14px 40px rgba(15, 23, 42, 0.10);
  overflow: hidden;
  box-sizing: border-box;
}

/* Style for chat message list */
.chat-list {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 14px 14px 10px;
  background: #f8fafc;
  box-sizing: border-box;
}

.chat-empty {
  margin: auto;
  text-align: center;
  color: rgba(100, 116, 139, 0.9);
  font-weight: 600;
  padding: 20px 16px;
}

.chat-list li {
  list-style: none;
}

.chat-text {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.35;
}

/* Style for chat message item */
.chat-item {
  max-width: 86%;
  min-width: 0;
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 16px;
  box-shadow: none;
  width: fit-content;
}

/* Style for chat message item: sender */
.chat-item-sender {
  background: linear-gradient(135deg, #0b98ff 0%, #2563eb 100%);
  color: #ffffff;
  align-self: flex-end;
  margin-left: auto;
  border-radius: 16px 16px 8px 16px;
  text-align: right;
}

/* Style for chat message item: receiver */
.chat-item-receiver {
  background: #e0f2fe;
  color: #0f172a;
  align-self: flex-start;
  margin-right: auto;
  border-radius: 16px 16px 16px 8px;
  text-align: left;
}

/* Better fit for long log/command output */
.chat-text {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/* Style for chat input form */
.chat-form {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background-color: #ffffff;
  width: 100%;
  min-width: 0;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  margin-top: auto;
  box-sizing: border-box;
}

/* Override bootstrap pt-4 (if any) to keep form anchored correctly */
.chat-form.pt-4 {
  padding-top: 12px !important;
}

/* Style for chat input field */
.chat-input {
  flex: 1 1 auto;
  min-width: 0;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  font-size: 15px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
  background: #fff;
  outline: none;
  box-sizing: border-box;
}

.chat-input:focus {
  border-color: rgba(37, 99, 235, 0.45);
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.16);
}

.timeout-input {
  flex: 0 0 auto;
  padding: 10px 14px;
  border-radius: 999px;
  border: none;
  font-size: 15px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
  background: #fff;
  outline: none;
  width: 110px;
  text-align: center;
  box-sizing: border-box;
}

/* Style for chat send button */
.chat-send {
  flex: 0 0 auto;
  border: none !important;
  border-radius: 999px !important;
  height: 44px;
  padding: 0 18px !important;
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 14px 40px rgba(37, 99, 235, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
  box-sizing: border-box;
}

.chat-send:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 54px rgba(37, 99, 235, 0.32);
}

.chat-send i {
  font-size: 14px;
}

@media (max-width: 576px) {
  .atcmd-col {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }

  .chat-container {
    min-height: 420px;
    height: 78vh;
  }

  .chat-form {
    padding: 8px 6px;
    gap: 6px;
  }

  .timeout-input {
    width: 76px;
    padding: 10px 8px;
  }

  .chat-send {
    min-width: 62px;
    padding: 0 10px !important;
  }

  .chat-send i {
    margin-right: 0 !important;
  }
}
</style>
